
    var riot = require('riot')
    //src: starling/src/tags/regions.html
riot.tag2('regions',
  '<region canvas="{parent.canvas}" each="{this.getRegions()}"></region>',
  '',
  '', function(opts) {
'use strict';

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _regionUi = require('lib/region-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = opts.canvas;
canvas.regionsTag = this;
this.canvas = canvas;

this.getRegions = function () {
  var regions = _store_instance2.default.getRegions();
  return regions;
};

this.on('mount', function () {
  _regionUi.regionUI.setupDragging();
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('regions')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/regions.html
// module id = 752
// module chunks = 0